module.exports = __webpack_public_path__ + "img/clipart.45c942f8.svg";